<template>
    <div>
        <b-button variant="dark" @click="show = true"><i class="fa fa-code"></i> </b-button>
        <b-modal title="Libraries" v-model="show">
            <b-list-group>
              <b-list-group-item v-for="lib in libs" :key="lib.name" :href="lib.docs" target="_blank">
                <template v-if="lib.varName">
                    {{ lib.name }} <strong>as</strong> {{ lib.varName }}
                </template>

                <template v-else>
                    {{ lib.name }}
                </template>
              </b-list-group-item>
            </b-list-group>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "Libs",
    props: {
        libs: {
            type: Array
        }
    },
    data: function() {
        return {
            show: false
        }
    }
}
</script>